import cn from 'classnames';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

interface Props {
  q: string | null;
  onSubmit: (q: string) => void;
}

const SearchInput: React.FC<Props> = ({ q: urlQ, onSubmit }) => {
  const [q, setQ] = useState(urlQ || '');

  useEffect(() => {
    setQ(urlQ || '');
  }, [urlQ]);

  const { t } = useTranslation();

  return (
    <div className="container jg-space-phms@md">
      <form
        action="" // action attr required for iPhone keyboard Search button
        role="search"
        className={cn(
          'jg-search__form',
          'jg-display-flex',
          'jg-bdb jg-bd--very-light-grey',
          'jg-bd@md jg-br@md',
          'jg-space-mvms@md jg-space-psm@md',
          'jg-w-3/4@md jg-space-mha@md',
          'jg-w-2/3@lg',
          'jg-w-1/2@xl'
        )}
        onSubmit={e => {
          e.preventDefault();

          // Blur the input so the mobile keyboard disappears
          document.activeElement instanceof HTMLElement &&
            document.activeElement.blur();

          onSubmit(q);
        }}
      >
        <input
          type="search"
          name="search"
          title={t('searchBox.inputTitle', 'Search query')}
          autoFocus={q === ''}
          className={cn(
            'jg-search__input',
            'jg-flex-g1 jg-flex-s1',
            'jg-form-control',
            'jg-bdn',

            // NB 16px/medium is the minimum to prevent the mobile auto-zoom behaviour
            'jg-font-size--medium'
          )}
          onChange={e => setQ(e.target.value)}
          placeholder={t(
            'searchBox.inputPlaceholder',
            'Search for a friend or charity'
          )}
          value={q}
        />
        <input
          type="submit"
          className={cn(
            'jg-search__button',
            'jg-flex-g0 jg-flex-s0',
            'jg-btn jg-br--0 jg-br@md'
          )}
          value={t<string>('searchBox.buttonText', 'Search')}
        />
      </form>
    </div>
  );
};
export default SearchInput;
